import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { type RimmEntityType, type RimmSubEntityType } from '../data/rimmEntityEnums';
import { rimmSubEntitySelector } from '../store/selectors';
import { fetchRimmEntityByCode } from '../services';
import { setSubEntityData } from '../store/slices';

export const useRimmSubEntity = <T extends RimmSubEntityType, P extends RimmEntityType>(
  entity: T,
  parentEntity: P,
  code: string | number,
  outerRimmServerURL?: string
) => {
  const dispatch = useDispatch();
  const { data: rimmEntities } = useSelector(rimmSubEntitySelector(entity, code));

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (rimmEntities.length || typeof code === 'undefined') {
      return;
    }

    setLoading(true);
    fetchRimmEntityByCode({ entity: parentEntity, code, outerRimmServerURL })
      .then(({ data }) => {
        // @ts-expect-error - TODO: fix
        const subentities = data[entity] ?? [];
        dispatch(setSubEntityData({ data: subentities, entity, code: data.code }));
      })
      .catch((error) => console.error(error))
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch, parentEntity, entity, code, outerRimmServerURL, rimmEntities.length]);

  return {
    rimmEntities,
    loading,
  };
};
